import { config } from "./config";

export const FONTS = {
  default: [
    "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Krona+One&display=swap",
  ],
  rnr: ["https://fonts.googleapis.com/css2?family=Sacramento&display=swap"],
};

type ClientIdConfig = {
  axisClientId: string;
  tdClientId: string;
  bajajClientId: string;
  godrejPropertiesClientId: string;
  moneycontrolClientId: string;
  kotakClientId: string;
  onePercentClientId: string;
  stooferClientId: string;
  raisoniClientId: string;
  momentsRnrClientId: string;
  redeemHubbleClientId: string;
  brenClientId: string;
  visitHealthRewardsClientId: string;
  buddydealsClientId: string;
  brandLookBookClientId: string;
  nielsenClientId: string;
  eazyErpClientId: string;
  eazyErpCromptonClientId: string;
};

const CLIENT_ID_CONFIGS: Record<string, ClientIdConfig> = {
  prod: {
    axisClientId: "axisbank-llE1XBk0",
    raisoniClientId: "raisoni-A8Aa6FsT",
    tdClientId: "tata-digital-HmS62avt",
    bajajClientId: "bajajfinserv-CyyetFBG",
    godrejPropertiesClientId: "godrej-properties-rnr-FsDd6dSt",
    moneycontrolClientId: "moneycontrol-2lABGigG",
    momentsRnrClientId: "demo-hubble-c5m2Dvjd",
    redeemHubbleClientId: "redeem-hubble-wUk8BaJg",
    visitHealthRewardsClientId: "visit-health-rewards-Vj47UiA1",
    kotakClientId: "kotak-3GwSL6LLgP4Y",
    onePercentClientId: "one-percent-v2-0MAtl8AH",
    stooferClientId: "stoofers-1F9eGgKR",
    brenClientId: "bren-GVY69LmI",
    buddydealsClientId: "buddydeals-enR9L4ya",
    nielsenClientId: "nielseniq-76CHcQcM",
    eazyErpClientId: "eazyerp-crompton-ozvoGkRK",
    eazyErpCromptonClientId: "eazyerp-crompton-ozvoGkRK",
    brandLookBookClientId: "brand-look-book-JgMDEqwz",
  },
  nonProd: {
    axisClientId: "acme-code-3241c2c1",
    raisoniClientId: "raisoni-dev",
    tdClientId: "tata-digital-23gvn314",
    bajajClientId: "bajaj-code-Bp3sxUCw",
    godrejPropertiesClientId: "godrej-properties-rnr-LEj5WNL5",
    moneycontrolClientId: "moneycontrol-QH53rltu",
    momentsRnrClientId: "acme-3241c2c1",
    redeemHubbleClientId: "redeem-hubble-059mzyEK",
    visitHealthRewardsClientId: "visit-health-rewards-mkyspH1P",
    kotakClientId: "kotak-sdk",
    onePercentClientId: "one-percent-v2-Fmozeq0e",
    stooferClientId: "stoofers-oPExjdmx",
    brenClientId: "bren-I9Up5fKI",
    buddydealsClientId: "buddydeals-dL9Z7lL1",
    nielsenClientId: "nielsen-QEjZqzmO",
    eazyErpClientId: "eazyerp-AtxiyhVX",
    eazyErpCromptonClientId: "eazyerp-crompton-IEhYJ60L",
    brandLookBookClientId: "brand-look-book-dev-XbTiXPF7",
  },
};

export const clientIdConfig =
  config.env === "Prod" ? CLIENT_ID_CONFIGS.prod : CLIENT_ID_CONFIGS.nonProd;

const iframeEmbedHost = {
  prod: {
    visitHealthRewardsClientId: {
      host: "visit-health-rewards.hubble-rewards.com",
      clientId: clientIdConfig.visitHealthRewardsClientId,
      clientSecret:
        "lq3ExGzyyhB5aP6YAJ1eXSHlsGwAMOVsstsquafU7lCHDVuP8qJvMzzJXxWNqLJy",
    },
  },
  nonProd: {
    visitHealthRewardsClientId: {
      host: "visit-health-rewards.dev.hubble-rewards.com",
      clientId: clientIdConfig.visitHealthRewardsClientId,
      clientSecret:
        "uVh2zkcGSWr0VZKZefrHYnTCuj8B89x2XUAO5HjPWIWhvlB96PAp2AvylDC2uAPc",
    },
  },
};

export const iframeEmbedHostConfig =
  config.env === "Prod" ? iframeEmbedHost.prod : iframeEmbedHost.nonProd;

export function accomodateHigherBrandsPerRowOnHomeForCodeBasedPortal(
  clientId?: string
): boolean {
  // true only for td client
  return clientId === clientIdConfig.tdClientId;
}

export function isHostOnlyForIframeEmbed(host: string) {
  return (
    host === "visit-health-rewards.dev.hubble-rewards.com" ||
    host === "visit-health-rewards.hubble-rewards.com"
  );
}

export function getVoucherDescBrandingReplacement(clientId: string): string {
  /*
  Eg.
  Default - Access discounts on groceries and household essentials at Bigbasket with a discounted gift card from Hubble.

  For Raisoni
  Access discounts on groceries and household essentials at Bigbasket with a discounted gift card from Raisoni Privilege.
  */
  if (clientId === clientIdConfig.raisoniClientId) {
    return "Raisoni Privilege";
  } else if (clientId === clientIdConfig.buddydealsClientId) {
    return "Buddy Deal";
  } else if (clientId === clientIdConfig.nielsenClientId) {
    return "NielsenIQ";
  }

  return "Hubble";
}

export function shouldDisableLogout(clientId?: string): boolean {
  // Disable logout for Visit Health Rewards client (embedded iframe scenarios)
  return clientId === clientIdConfig.visitHealthRewardsClientId;
}
